import box from './box/box.vue';
import infoBox from './info-box/info-box.vue';
import smallBox from './small-box/small-box.vue';
import alert from './alert/alert.vue';
import progress from './progress/progress.vue';
import pagination from './pagination/pagination.vue';
import tabset from './tabset/tabset.vue';
import tabItem from './tabset/tab-item.vue';
import modal from './modal/modal.vue';
import timeline from './timeline/timeline.vue';
import timelineItem from './timeline/timeline-item.vue';
import rating from './rating/rating.vue';
import tag from './tag/tag.vue';
import tagInput from './tag-input/tag-input.vue';

export const COMPONENTS = [
  box,
  infoBox,
  smallBox,
  alert,
  progress,
  pagination,
  tabset, tabItem,
  modal,
  timeline, timelineItem,
  rating,
  tag, tagInput
];



// WEBPACK FOOTER //
// ./src/components/index.js